// Cross-subdomain language persistence. `glp_lang` is written on
// `.grocerylistplus.com` so the public site (www), the consumer app, and the
// vendor portal all read the same value (mirrors the consumer app's
// langCookie). localStorage wouldn't work — it's scoped per-origin.

const COOKIE_NAME = 'glp_lang';
const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;
const SUPPORTED: ReadonlySet<string> = new Set(['en', 'es']);

function parentDomainAttr(): string {
  if (typeof window === 'undefined') return '';
  const host = window.location.hostname;
  if (host.endsWith('grocerylistplus.com')) {
    return '; domain=.grocerylistplus.com';
  }
  return '';
}

export function readLangCookie(): 'en' | 'es' | null {
  if (typeof document === 'undefined') return null;
  const raw = document.cookie
    .split(';')
    .map((s) => s.trim())
    .find((s) => s.startsWith(`${COOKIE_NAME}=`));
  if (!raw) return null;
  const value = decodeURIComponent(raw.slice(COOKIE_NAME.length + 1));
  return SUPPORTED.has(value) ? (value as 'en' | 'es') : null;
}

export function writeLangCookie(lang: string): void {
  if (typeof document === 'undefined') return;
  if (!SUPPORTED.has(lang)) return;
  const secure =
    typeof window !== 'undefined' && window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie =
    `${COOKIE_NAME}=${encodeURIComponent(lang)}` +
    `; path=/` +
    `; max-age=${ONE_YEAR_SECONDS}` +
    `; SameSite=Lax` +
    secure +
    parentDomainAttr();
}
